/**
 * Icon mapping from scite icon names to Central icons
 *
 * All icons import from @central-icons-react/round-outlined-radius-1-stroke-1.5
 */

import { IconBubbleDots } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBubbleDots'
import { IconTrashCan } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconTrashCan'
import { IconPencil } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconPencil'
import { IconEditSmall1 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconEditSmall1'
import { IconOpenQuote2 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconOpenQuote2'
import { IconShareOs } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconShareOs'
import { IconClipboard2 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconClipboard2'
import { IconFileDownload } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconFileDownload'
import { IconArrowWallDown } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowWallDown'
import { IconMagnifyingGlass } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconMagnifyingGlass'
import { IconPlusLarge } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconPlusLarge'
import { IconMinusLarge } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconMinusLarge'
import { IconCrossMedium } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCrossMedium'
import { IconCheckmark1 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCheckmark1'
import { IconSquareArrowTopRight } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconSquareArrowTopRight'
import { IconCircleQuestionmark } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCircleQuestionmark'
import { IconCircleInfo } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCircleInfo'
import { IconExclamationTriangle } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconExclamationTriangle'
import { IconSettingsGear2 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconSettingsGear2'
import { IconSparkle } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconSparkle'
import { IconChevronRight } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconChevronRight'
import { IconChevronLeft } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconChevronLeft'
import { IconChevronBottom } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconChevronBottom'
import { IconChevronTop } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconChevronTop'
import { IconMinimize45 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconMinimize45'
import { IconExpand45 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconExpand45'
import { IconDotGrid1x3Vertical } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconDotGrid1x3Vertical'
import { IconDotGrid1x3Horizontal } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconDotGrid1x3Horizontal'
import { IconBookmarkCheck } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBookmarkCheck'
import { IconFolder1 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconFolder1'
import { IconFolderAddRight } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconFolderAddRight'
import { IconArchive } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArchive'
import { IconEyeOpen } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconEyeOpen'
import { IconEyeSlash } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconEyeSlash'
import { IconTag } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconTag'
import { IconBell } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBell'
import { IconLightBulb } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconLightBulb'
import { IconCalendar2 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCalendar2'
import { IconSquareChecklistMagnifyingGlass } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconSquareChecklistMagnifyingGlass'
import { IconLayoutDashboard } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconLayoutDashboard'
import { IconSidebar } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconSidebar'
import { IconSidebarLeftArrow } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconSidebarLeftArrow'
import { IconArrowRight } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowRight'
import { IconArrowLeft } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowLeft'
import { IconArrowUp } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowUp'
import { IconArrowRightCircle } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowRightCircle'
import { IconLock } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconLock'
import { IconCircleCheck } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCircleCheck'
import { IconCircleX } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCircleX'
import { IconCirclePlus } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCirclePlus'
import { IconExclamationCircle } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconExclamationCircle'
import { IconFlag1 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconFlag1'
import { IconVolumeUp } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconVolumeUp'
import { IconMagicWand } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconMagicWand'
import { IconBubble2 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBubble2'
import { IconChainLink1 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconChainLink1'
import { IconFilter1 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconFilter1'
import { IconSettingsSliderThree } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconSettingsSliderThree'
import { IconColumns3 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconColumns3'
import { IconArrowUpRight } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowUpRight'
import { IconArrowBoxRight } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowBoxRight'
import { IconArrowShareRight } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowShareRight'
import { IconArrowWallRight } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowWallRight'
import { IconArrowRotateClockwise } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowRotateClockwise'
import { IconLayoutGrid2 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconLayoutGrid2'
import { IconBulletList } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBulletList'
import { IconZap } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconZap'
import { IconReadingList } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconReadingList'
import { IconBubblePlus } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBubblePlus'
import { IconGlobe2 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconGlobe2'
import { IconPageTextSearch } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconPageTextSearch'
import { IconShieldCheck } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconShieldCheck'
import { IconPeople } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconPeople'
import { IconTable } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconTable'
import { IconWindowCursor } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconWindowCursor'
import { IconApiConnection } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconApiConnection'
import { IconBrowserTabs } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBrowserTabs'
import { IconCurrencyDollar } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCurrencyDollar'
import { IconOrganisation } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconOrganisation'
import { IconBook } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBook'
import { IconPageText } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconPageText'
import { IconUser } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconUser'
import { IconTrending1 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconTrending1'
import { IconUserSettings } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconUserSettings'
import { IconPeopleAdd } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconPeopleAdd'
import { IconPeopleRemove } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconPeopleRemove'
import { IconClock } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconClock'
import { IconEmail1 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconEmail1'
import { IconKey1 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconKey1'
import { IconServer } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconServer'
import { IconUnlocked } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconUnlocked'
import { IconGauge } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconGauge'
import { IconClipboard } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconClipboard'
import { IconChecklist } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconChecklist'
import { IconZoomOut } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconZoomOut'
import { IconPlugin1 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconPlugin1'
import { IconPaperPlane } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconPaperPlane'
import { IconImages1 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconImages1'
import { IconPlay } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconPlay'
import { IconPause } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconPause'
import { IconChart1 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconChart1'
import { IconFormSeal } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconFormSeal'
import { IconShield } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconShield'
import { IconTwitter } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconTwitter'
import { IconLinkedin } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconLinkedin'
import { IconFacebook } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconFacebook'
import { IconGroup1 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconGroup1'
import { IconBarsThree } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBarsThree'
import { IconSortArrowUpDown } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconSortArrowUpDown'
import { IconArrowDown } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowDown'
import { IconChevronDoubleLeft } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconChevronDoubleLeft'
import { IconChevronDoubleRight } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconChevronDoubleRight'
import { IconRobot } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconRobot'
import { IconConnectors2 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconConnectors2'
import { IconBranch } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBranch'
import { IconCircleMinus } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCircleMinus'
import { IconArrowCornerLeftUp } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowCornerLeftUp'
import { IconArrowCornerDownRight } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowCornerDownRight'
import { IconSuitcaseWork } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconSuitcaseWork'
import { IconTranslate } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconTranslate'
import { IconBank } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBank'

/**
 * Maps scite icon names to Central React icon components.
 */
const ICON_MAP = {
  // Chat & Messaging
  chat: IconBubbleDots,
  newChat: IconBubblePlus,

  // Table & Data
  table: IconTable,

  // Actions
  trash: IconTrashCan,
  edit: IconPencil,
  editBox: IconEditSmall1,
  quote: IconOpenQuote2,
  share: IconShareOs,
  copy: IconClipboard2,
  download: IconFileDownload,
  downloadArrow: IconArrowWallDown,
  search: IconMagnifyingGlass,
  plus: IconPlusLarge,
  minus: IconMinusLarge,
  x: IconCrossMedium,
  check: IconCheckmark1,
  externalLink: IconSquareArrowTopRight,

  // UI Elements
  help: IconCircleQuestionmark,
  info: IconCircleInfo,
  warning: IconExclamationTriangle,
  settings: IconSettingsGear2,
  sparkles: IconSparkle,

  // Navigation
  chevronRight: IconChevronRight,
  chevronLeft: IconChevronLeft,
  chevronDown: IconChevronBottom,
  chevronUp: IconChevronTop,
  minimize: IconMinimize45,
  maximize: IconExpand45,

  // Sidebar
  sidebarCollapsed: IconSidebar,
  sidebarExpanded: IconSidebarLeftArrow,

  // Menus
  moreVertical: IconDotGrid1x3Vertical,
  moreHorizontal: IconDotGrid1x3Horizontal,

  // Misc
  bookmarkCheck: IconBookmarkCheck,
  folder: IconFolder1,
  folderAddRight: IconFolderAddRight,
  archive: IconArchive,
  eye: IconEyeOpen,
  eyeOff: IconEyeSlash,
  tag: IconTag,
  bell: IconBell,
  lightbulb: IconLightBulb,
  calendar: IconCalendar2,
  searchChecklist: IconSquareChecklistMagnifyingGlass,
  dashboardLayout: IconLayoutDashboard,

  // Arrows
  arrowRight: IconArrowRight,
  arrowLeft: IconArrowLeft,
  arrowUp: IconArrowUp,
  arrowCircleRight: IconArrowRightCircle,
  arrowUpRight: IconArrowUpRight,
  regenerate: IconArrowRotateClockwise,

  // Status
  lock: IconLock,
  checkCircle: IconCircleCheck,
  timesCircle: IconCircleX,
  plusCircle: IconCirclePlus,
  exclamationCircle: IconExclamationCircle,

  // Other
  flag: IconFlag1,
  volumeUp: IconVolumeUp,
  magicWand: IconMagicWand,
  comment: IconBubble2,
  link: IconChainLink1,
  filter: IconFilter1,
  adjustments: IconSettingsSliderThree,
  columns: IconColumns3,

  // Feature icons
  mcp: IconWindowCursor,
  api: IconApiConnection,
  browserExtension: IconBrowserTabs,
  funders: IconCurrencyDollar,
  organizations: IconOrganisation,
  journals: IconBook,
  literatureReviews: IconReadingList,
  patents: IconPageText,

  // Sidebar / Profile
  bio: IconUser,
  metrics: IconTrending1,
  subscription: IconCurrencyDollar,
  accountSettings: IconUserSettings,
  signOut: IconArrowBoxRight,

  // Homepage features
  globalCoverage: IconGlobe2,
  fullTextSearch: IconPageTextSearch,
  smartCitations: IconBookmarkCheck,
  verifiableEvidence: IconShieldCheck,
  trustedByMillions: IconPeople,

  // Context menu
  shareRight: IconArrowShareRight,
  export: IconArrowWallRight,

  // View modes
  layoutGrid: IconLayoutGrid2,
  bulletList: IconBulletList,

  // Status indicators
  zap: IconZap,

  // People & roles
  user: IconUser,
  users: IconPeople,
  userPlus: IconPeopleAdd,
  userRemove: IconPeopleRemove,
  shieldCheck: IconShieldCheck,
  clock: IconClock,
  mail: IconEmail1,

  // Admin & infrastructure
  key: IconKey1,
  server: IconServer,
  unlock: IconUnlocked,
  gauge: IconGauge,
  clipboard: IconClipboard,
  checklist: IconChecklist,
  seal: IconFormSeal,
  shield: IconShield,
  plugin: IconPlugin1,
  paperPlane: IconPaperPlane,
  image: IconImages1,
  zoomOut: IconZoomOut,
  userGroup: IconGroup1,
  chart: IconChart1,
  book: IconBook,
  fileText: IconPageText,

  // Media controls
  play: IconPlay,
  pause: IconPause,

  // Social
  twitter: IconTwitter,
  linkedin: IconLinkedin,
  facebook: IconFacebook,

  // Menus & sorting
  menu: IconBarsThree,
  sortArrows: IconSortArrowUpDown,

  // Arrows & chevrons
  arrowDown: IconArrowDown,
  chevronDoubleLeft: IconChevronDoubleLeft,
  chevronDoubleRight: IconChevronDoubleRight,
  levelUp: IconArrowCornerLeftUp,
  enter: IconArrowCornerDownRight,

  // Graphs & structure
  robot: IconRobot,
  network: IconConnectors2,
  hierarchy: IconBranch,
  minusCircle: IconCircleMinus,

  // Patents filter facets, named by the icon the patents schema asks for
  briefcase: IconSuitcaseWork,
  language: IconTranslate,
  landmark: IconBank
}

export type IconName = keyof typeof ICON_MAP

export default ICON_MAP
